<Navbar />

<div :class="[wrapper_class, 'd-flex', 'aic-mobile-page', 'aic-create-page', 'aic-mobile-content']">
  <Sidebar />

  <div class="hero-section w-100 aic-safe-bottom">

    <div class="bg-white bg-opacity-75 rounded-4 p-2 mb-4 shadow-sm border">
      <div class="d-flex gap-1 overflow-auto tabs-scroll">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          class="btn d-flex align-items-center gap-2 px-3 py-2 rounded-3 border-0 text-nowrap tab-btn"
          :class="active_tab === tab.value ? 'tab-active' : 'bg-transparent text-secondary'"
          @click="active_tab = tab.value"
        >
          <i :class="tab.icon"></i>
          <span class="fw-medium small">{{ tab.label }}</span>
        </button>
      </div>
    </div>

    <!-- HOME TAB -->
    <div v-if="active_tab === 'home'" class="workspace-content">
      <div class="home-wrapper">


        <div
          v-if="allowed_app_keys.length === 0"
          class="empty-state-container d-flex flex-column align-items-center justify-content-center py-5 mt-3"
        >
          <div class="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle mb-4">
            <i class="bi bi-grid-6x6-gap"></i>
          </div>

          <h5 class="fw-semibold mb-2">No platforms assigned yet</h5>

          <p class="text-muted small text-center mb-0">
            You don't have access to any platforms at the moment.
            Contact your administrator to request access.
          </p>
        </div>

        <div v-else class="row g-4">

        <h2 class="fw-bold gradient-text text-center mb-2">Welcome to My Workspace</h2>
        <p class="text-muted text-center mb-4">Personal workspace with all tools</p>

          <!-- ORCAA AI -->
          <div v-if="allowed_app_keys.includes('orcaa')" class="col-md-6 col-lg-4">
            <div class="card feature-card shadow-sm p-4 h-100 d-flex flex-column">
              <div class="feature-head">
                <div class="feature-icon mb-3 d-flex align-items-center justify-content-center">
                  <div class="platform-icon-circle purple bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-4">
                    <img :src="card_images.orcaa" class="icon-32 object-fit-contain" />
                  </div>
                </div>
                <h5 class="fw-bold mb-2">Orcaa AI</h5>
                <p class="text-muted small mb-0">Education & Learning</p>
              </div>
              <div class="feature-body mt-3">
                <p class="text-muted small mb-3">
                  AI-powered learning intelligence platform for personalized education,
                  skills development, and learner insights.
                </p>
              </div>
              <button class="btn upload-button w-100 mt-auto" @click="launch_and_open('orcaa')">
                Continue Learning →
              </button>
            </div>
          </div>

          <!-- PROBA WORKFLOWS -->
          <div v-if="allowed_app_keys.includes('workflow')" class="col-md-6 col-lg-4">
            <div class="card feature-card shadow-sm p-4 h-100 d-flex flex-column">
              <div class="feature-head">
                <div class="feature-icon mb-3 d-flex align-items-center justify-content-center">
                  <div class="platform-icon-circle bg-success bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-4">
                    <img :src="card_images.workflows" class="icon-32 object-fit-contain" />
                  </div>
                </div>
                <h5 class="fw-bold mb-2">Proba Workflows</h5>
                <p class="text-muted small mb-0">Automation & Processes</p>
              </div>
              <div class="feature-body mt-3">
                <p class="text-muted small mb-3">
                  AI-powered workflow automation, data mapping, and process building
                  for seamless business operations.
                </p>
              </div>
              <button class="btn upload-button w-100 mt-auto" @click="launch_and_open('workflows')">
                View Workflows →
              </button>
            </div>
          </div>

          <!-- COMPLYON -->
          <div v-if="allowed_app_keys.includes('complyon')" class="col-md-6 col-lg-4">
            <div class="card feature-card shadow-sm p-4 h-100 d-flex flex-column">
              <div class="feature-head">
                <div class="feature-icon mb-3 d-flex align-items-center justify-content-center">
                  <div class="platform-icon-circle green bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-4">
                    <img :src="card_images.complyon" class="icon-32 object-fit-contain" />
                  </div>
                </div>
                <h5 class="fw-bold mb-2">ComplyOn</h5>
                <p class="text-muted small mb-0">Company & Compliance</p>
              </div>
              <div class="feature-body mt-3">
                <p class="text-muted small mb-3">
                  Smart stakeholder onboarding, automated compliance checks,
                  and continuous risk monitoring.
                </p>
              </div>
              <button class="btn upload-button w-100 mt-auto" @click="launch_and_open('complyon')">
                Review Now →
              </button>
            </div>
          </div>

          <!-- X-VERDICT -->
          <div v-if="allowed_app_keys.includes('x-verdict')" class="col-md-6 col-lg-4">
            <div class="card feature-card shadow-sm p-4 h-100 d-flex flex-column">
              <div class="feature-head">
                <div class="feature-icon mb-3 d-flex align-items-center justify-content-center">
                  <div class="platform-icon-circle bg-info bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-4">
                    <img :src="card_images.xverdict" class="icon-32 object-fit-contain" />
                  </div>
                </div>
                <h5 class="fw-bold mb-2">X-Verdict</h5>
                <p class="text-muted small mb-0">Legal & Adjudication</p>
              </div>
              <div class="feature-body mt-3">
                <p class="text-muted small mb-3">
                  AI-powered legal analysis and case management for
                  efficient adjudication and decision-making.
                </p>
              </div>
              <button class="btn upload-button w-100 mt-auto" @click="launch_and_open('xverdict')">
                Explore Cases →
              </button>
            </div>
          </div>

          <!-- PROBA ANALYTICS -->
          <div v-if="allowed_app_keys.includes('proba')" class="col-md-6 col-lg-4">
            <div class="card feature-card shadow-sm p-4 h-100 d-flex flex-column">
              <div class="feature-head">
                <div class="feature-icon mb-3 d-flex align-items-center justify-content-center">
                  <div class="platform-icon-circle bg-danger bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-4">
                    <img :src="card_images.analytics" class="icon-32 object-fit-contain" />
                  </div>
                </div>
                <h5 class="fw-bold mb-2">Proba Analytics</h5>
                <p class="text-muted small mb-0">Data & Insights</p>
              </div>
              <div class="feature-body mt-3">
                <p class="text-muted small mb-3">
                  Real-time dashboards, KPI tracking, and business intelligence
                  for data-driven decisions.
                </p>
              </div>
              <button class="btn upload-button w-100 mt-auto" @click="active_tab = 'analytics'">
                View Analytics →
              </button>
            </div>
          </div>

          <!-- ENGAGENET -->
          <div v-if="allowed_app_keys.includes('engagenet')" class="col-md-6 col-lg-4">
            <div class="card feature-card shadow-sm p-3 p-sm-4 h-100 d-flex flex-column">
              <div class="feature-head">
                <div class="feature-icon mb-3 d-flex align-items-center justify-content-center">
                  <div class="platform-icon-circle bg-secondary bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-4">
                    <img :src="card_images.engagenet" class="icon-32 object-fit-contain" />
                  </div>
                </div>
                <h5 class="fw-bold mb-2">EngageNet</h5>
                <p class="text-muted small mb-0">Documentation & Records</p>
              </div>
              <div class="feature-body mt-3">
                <p class="text-muted small mb-3">
                  Centralized workbook for documentation, record keeping,
                  and structured information management.
                </p>
              </div>
              <button class="btn upload-button w-100 mt-auto" @click="launch_and_open('icworkbook')">
                Open Workbook
              </button>
            </div>
          </div>

        </div>

      </div>
    </div>

    <!-- OTHER TABS -->
    <div v-else class="workspace-content">
      <component :is="active_component" />
    </div>

  </div>
</div>
